import { render, staticRenderFns } from "./CheckinsSummary.vue?vue&type=template&id=64820ee4&"
import script from "./CheckinsSummary.vue?vue&type=script&lang=js&"
export * from "./CheckinsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports